<template>
    <header class="account__section-header">
        <div>
            <h2 class="h3">{{ heading }}</h2>
            <span class="account__section-tick small semi" :class="{'is-completed' : completed === toComplete}">
                {{ completed }}/{{ toComplete }} complete
                <figure>
                    <svg class="icon">
                        <use xlink:href="#tick" />
                    </svg>
                </figure>
            </span>
        </div>
        <hr>
    </header>
</template>
<script>
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        completed: {
            type: Number,
            required: true,
        },
        toComplete: {
            type: Number,
            required: true,
        },
    },
}
</script>
